const ForceInt = (val) => {
	/*
        This function forces an integer. If everything fails, it will
        return 0.
    */

	let value = val;

	try {
		value = parseInt(value, 10);
	} catch (ermahgerd) {
		value = 0;
	}

	// if we still get NaN, make it zero
	if (Number.isNaN(value)) {
		value = 0;
	}

	return value;
};

export default ForceInt;
